import { type Address, getAddress, zeroAddress } from "viem"
import * as chains from "viem/chains"
import * as customChains from "../../chains"
import type { SupportedChainId } from "../../config"

export const NATIVE_ADDRESS = getAddress(
  "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
)
export const USD_ADDRESS = getAddress(
  `0x${(840).toString(16).padStart(40, "0")}`,
)
// ONLY FOR SONIC
export const WSONIC_ADDRESS = getAddress(
  "0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38",
)
export const WAVAX_ADDRESS = getAddress(
  "0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7",
)
export const WBERA_ADDRESS = getAddress(
  "0x6969696969696969696969696969696969696969",
)
export const WBNB_ADDRESS = getAddress(
  "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c",
)
export const BTC_ADDRESS = getAddress(
  "0xbBbBBBBbbBBBbbbBbbBbbbbBBbBbbbbBbBbbBBbB",
)
export const WHYPE_ADDRESS = getAddress(
  "0x5555555555555555555555555555555555555555",
)
export const WTAC_ADDRESS = getAddress(
  "0xB63B9f0eb4A6E6f191529D71d4D88cc8900Df2C9",
)

export const WXPL_ADDRESS = getAddress(
  "0x6100E367285b01F48D07953803A2d8dCA5D19873",
)
export const WMNT_ADDRESS = getAddress(
  "0x78c1b0C915c4FAA5FffA6CAbf0219DA63d7f4cb8",
)
export const WMON_ADDRESS = getAddress(
  "0x3bd359C1119dA7Da1D913D1C4D2B7c461115433A",
)

export const WETH9: Record<SupportedChainId, Address> = {
  [chains.mainnet.id]: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
  [chains.foundry.id]: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
  [chains.arbitrum.id]: "0x82af49447d8a07e3bd95bd0d56f35241523fbab1",
  [chains.base.id]: "0x4200000000000000000000000000000000000006",
  [customChains.swell.id]: "0x4200000000000000000000000000000000000006",
  [customChains.sonic.id]: "0x50c42dEAcD8Fc9773493ED674b675bE577f2634b",
  [chains.sepolia.id]: "0xB4FBF271143F4FBf7B91A5ded31805e42b2208d6",
  [customChains.tenderly.id]: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
  [customChains.bartio.id]: "0x2F6F07CDcf3588944Bf4C42aC74ff24bF56e7590",
  [customChains.berachain.id]: "0x2F6F07CDcf3588944Bf4C42aC74ff24bF56e7590",
  [customChains.ink.id]: "0x4200000000000000000000000000000000000006",
  [customChains.unichain.id]: "0x4200000000000000000000000000000000000006",
  [chains.avalanche.id]: "0xE28AfD8c634946833e89ee3F122C06d7C537E8A8",
  [customChains.bob.id]: "0x4200000000000000000000000000000000000006",
  [chains.bsc.id]: "0x2170ed0880ac9a755fd29b2688956bd959f933f8",
  [customChains.hyperevm.id]: zeroAddress, // TODO:@dani PENDING CHECK
  [customChains.tac.id]: zeroAddress, // TODO:@dani PENDING CHECK
  [chains.linea.id]: "0xe5d7c2a44ffddf6b295a15c148167daaaf5cf34f",
  [customChains.plasma.id]: "0x9895D81bB462A195b4922ED7De0e3ACD007c32CB",
  [chains.mantle.id]: "0xdEAddEaDdeadDEadDEADDEAddEADDEAddead1111",
  [customChains.monad.id]: "0xEE8c0E9f1BFFb4Eb878d8f15f368A02a35481242",
} as const

// USDC Address
export const USDCA: Record<SupportedChainId, Address> = {
  [chains.mainnet.id]: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
  [chains.foundry.id]: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
  [chains.arbitrum.id]: "0xaf88d065e77c8cc2239327c5edb3a432268e5831",
  [chains.base.id]: "0x833589fcd6edb6e08f4c7c32d4f71b54bda02913",
  [customChains.swell.id]: zeroAddress, // THERE IS NO USDC ON BERACHAIN
  [customChains.sonic.id]: "0x29219dd400f2Bf60E5a23d13Be72B486D4038894",
  [chains.sepolia.id]: "0x07865c6e87b9f70255377e024ace6630c1eaa37f",
  [customChains.tenderly.id]: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
  [customChains.bartio.id]: "0x127c6d59fE30b67e81915EEA3CDcF7ae7D0f21Fb",
  // Need to check
  [customChains.berachain.id]: zeroAddress, // THERE IS NO USDC ON BERACHAIN
  [customChains.ink.id]: zeroAddress, // TODO:@dani PENDING CHECK
  [customChains.unichain.id]: "0x078d782b760474a361dda0af3839290b0ef57ad6",
  [chains.avalanche.id]: "0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e",
  [customChains.bob.id]: "0xe75D0fB2C24A55cA1e3F96781a2bCC7bdba058F0",
  [chains.bsc.id]: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
  [customChains.hyperevm.id]: zeroAddress, // TODO:@dani PENDING CHECK
  [customChains.tac.id]: zeroAddress, // TODO:@dani PENDING CHECK
  [chains.linea.id]: "0x176211869ca2b568f2a7d4ee941e073a821ee1ff",
  [chains.mantle.id]: "0x09bc4e0d864854c6afb6eb9a9cdf58ac190d0df9",
  [customChains.plasma.id]: "0xB8CE59FC3717ada4C02eaDF9682A9e934F625ebb",
  [customChains.monad.id]: "0x754704Bc059F8C67012fEd69BC8A327a5aafb603",
} as const
